document.addEventListener('DOMContentLoaded', function() {
    // If customer is not logged in, disable the panel button and exit.
    if (!customerEmail) {
        console.log('No customer logged in. Disabling Order Panel button.');
        const orderPanelButton = document.getElementById('order-panel-button');
        if (orderPanelButton) {
            orderPanelButton.style.pointerEvents = 'none';
            orderPanelButton.style.backgroundColor = '#ccc'; // Optional: Change button style
            orderPanelButton.textContent = "Sign In to Order Panel";
            orderPanelButton.href = "javascript:void(0);"; // Prevent navigation
        }
        return;
    }

    if (customerEmail && (customerEmail.endsWith('@ppg.com') || customerEmail.endsWith('@pittsburghpaints.com'))) {
        console.log('Customer has a PPG email address. Exiting script.');
        return;
    }

    if (hasInfinitePanelsTag) {
        console.log('Customer has InfinitePanels tag. Exiting script.');
        return;
    }

    const panelKeyword = "panel";
    const maxPanels = 10;

    console.log('Script loaded. Checking cart...');

    // Fetch cart details using Shopify's AJAX API
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            console.log('Cart fetched:', cart);

            let panelCount = 0;

            // Loop through cart items to count products whose handle contains "panel"
            cart.items.forEach(item => {
                console.log('Checking item handle:', item.handle);
                if (item.handle.toLowerCase().includes(panelKeyword)) {
                    panelCount += item.quantity;
                    console.log(`Panel item found: ${item.title} - Quantity: ${item.quantity}`);
                }
            });

            console.log(`Total panel count: ${panelCount}`);

            // Disable the "Order Panel" button if the limit is reached
            if (panelCount >= maxPanels) {
                const orderPanelButton = document.getElementById('order-panel-button');
                if (orderPanelButton) {
                    console.log('Disabling Order Panel button');
                    orderPanelButton.style.pointerEvents = 'none';
                    orderPanelButton.style.backgroundColor = '#ccc';
                    orderPanelButton.textContent = "Panel Limit Reached";
                    orderPanelButton.href = "javascript:void(0);";
                }
            } else {
                console.log('Panel limit not reached, button remains active.');
            }
        })
        .catch(error => console.error('Error fetching cart:', error));
});
